import React from 'react';

export default function ScoreCard({ score, classification }) {
  const getClass = () => {
    if (score >= 70) return 'safe';
    if (score >= 40) return 'warning';
    return 'danger';
  };

  const getLabel = () => {
    if (score >= 70) return 'URL Segura';
    if (score >= 40) return 'Atenção Necessária';
    return 'URL Perigosa';
  };

  const getDescription = () => {
    if (score >= 70) return 'Esta URL passou na maioria das verificações de segurança e apresenta baixo risco.';
    if (score >= 40) return 'Alguns indicadores suspeitos foram detectados. Prossiga com cautela.';
    return 'Múltiplos indicadores de risco foram detectados. Evite acessar esta URL.';
  };

  const cls = getClass();
  const circumference = 2 * Math.PI * 55;
  const offset = circumference - (score / 100) * circumference;

  const strokeColor = cls === 'safe' ? '#10b981' : cls === 'warning' ? '#f59e0b' : '#ef4444';

  return (
    <div className={`score-card ${cls}`}>
      <div className="score-circle">
        <svg viewBox="0 0 130 130" width="100%" height="100%">
          <circle
            cx="65" cy="65" r="55"
            fill="none"
            stroke="rgba(255,255,255,0.05)"
            strokeWidth="7"
          />
          <circle
            cx="65" cy="65" r="55"
            fill="none"
            stroke={strokeColor}
            strokeWidth="7"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 1.5s ease' }}
          />
        </svg>
        <span className="score-value">{score}</span>
        <span className="score-unit">/ 100</span>
      </div>
      <div className="score-label">{getLabel()}</div>
      <div className="score-description">{getDescription()}</div>
    </div>
  );
}
